var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
function convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
export class HeaderComponent extends Component {
    constructor() {
        super('HeaderComponent', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            let prevScrollPosition = window.pageYOffset;
            let hasWheelScrollOccured = false;
            let scrollIntervalID;
            $(window).on(['wheel', 'scroll'], (event) => {
                if ($('body').hasClass('lg-on'))
                    return;
                if (hasWheelScrollOccured && !event.deltaY)
                    return;
                if (event.deltaY) {
                    hasWheelScrollOccured = true;
                    window.clearInterval(scrollIntervalID);
                    scrollIntervalID = window.setInterval(() => {
                        hasWheelScrollOccured = false;
                    }, 1000);
                }
                const scrollPosition = window.pageYOffset | document.body.scrollTop;
                if (scrollPosition >= convertRemToPixels(8.8)) {
                    $('header').addClass('fixed');
                    window.setTimeout(() => {
                        $('header').addClass('transition');
                    }, 40);
                    let reactivateMenu = (hasWheelScrollOccured) ? event.deltaY < 0 : prevScrollPosition > window.pageYOffset;
                    if (reactivateMenu) {
                        $('header').addClass('in');
                    }
                    else {
                        $('header').removeClass('in');
                    }
                }
                else if (scrollPosition == 0) {
                    $('header').removeClass('transition');
                    $('header').removeClass('fixed');
                }
                prevScrollPosition = window.pageYOffset;
            });
            this.success();
        });
    }
}
